var _desc, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-340 7261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_stroke",
    transform: "translate(342 -7259)",
    fill: "#FFFFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_stroke",
    d: "M 3.5 6.5L 2.43934 7.56066L 3.5 8.62132L 4.56066 7.56066L 3.5 6.5ZM 8.93934 -1.06066L 2.43934 5.43934L 4.56066 7.56066L 11.0607 1.06066L 8.93934 -1.06066ZM 4.56066 5.43934L 1.06066 1.93934L -1.06066 4.06066L 2.43934 7.56066L 4.56066 5.43934Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheck);
export default __webpack_public_path__ + "static/media/checkbox_check.2093ee5b7c3d11564c0bfb81486c5df0.svg";
export { ForwardRef as ReactComponent };